import { ArrowRight } from "lucide-react";
import { trackWhatsappClick } from "@/lib/analytics";
import { buildSolutionWhatsappLink, solutionGroups } from "@/lib/commercial-content";

const SolutionsPage = () => (
  <main id="main-content" className="bg-[#0a0a0a] pt-24">
    <section className="relative overflow-hidden bg-[#0a0a0a] py-20 md:py-28">
      <div className="absolute inset-0 dot-pattern opacity-10 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="max-w-5xl mb-12 md:mb-16">
          <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-5">
            Soluções comerciais
          </div>
          <h1 className="font-display text-white text-[2.65rem] min-[380px]:text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.9]">
            Web, sistemas <span className="text-[#ff6b35]">e automação</span>
          </h1>
          <p className="mt-6 max-w-3xl text-white/75 text-lg sm:text-xl leading-snug">
            Escolha o ponto de partida certo para vender melhor, organizar processos e reduzir
            trabalho manual com tecnologia feita para a realidade da sua empresa.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-7">
          {solutionGroups.map((solution) => {
            const Icon = solution.icon;
            return (
              <article
                key={solution.n}
                className="brutal-card bg-white p-5 sm:p-7 lg:p-8 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(280px,420px)] gap-8"
              >
                <div>
                  <div className="flex flex-wrap items-start justify-between gap-4 mb-7">
                    <div className="flex items-center gap-4 min-w-0">
                      <div className="bg-[#0a0a0a] w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center brutal-border shrink-0">
                        <Icon size={26} className="text-[#ff6b35]" />
                      </div>
                      <div>
                        <p className="font-mono text-xs uppercase tracking-widest text-[#ff6b35]">
                          {solution.n}
                        </p>
                        <h2 className="font-display text-[#0a0a0a] text-3xl sm:text-5xl uppercase leading-none">
                          {solution.title}
                        </h2>
                      </div>
                    </div>
                    <p className="bg-[#ff6b35] text-[#0a0a0a] brutal-border px-4 py-2 font-mono text-xs uppercase tracking-widest">
                      {solution.price}
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                      <h3 className="font-mono text-xs uppercase tracking-widest text-[#0a0a0a] mb-2">
                        Para quem
                      </h3>
                      <p className="text-[#0a0a0a]/75 leading-snug">{solution.forWho}</p>
                    </div>
                    <div>
                      <h3 className="font-mono text-xs uppercase tracking-widest text-[#0a0a0a] mb-2">
                        Problemas
                      </h3>
                      <ul className="space-y-2 text-[#0a0a0a]/75 leading-snug">
                        {solution.problems.map((problem) => (
                          <li key={problem} className="flex gap-2">
                            <span className="mt-2 h-2 w-2 bg-[#ff6b35] brutal-border shrink-0" />
                            <span>{problem}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                <aside className="bg-[#0a0a0a] text-white brutal-border p-5 sm:p-6 flex flex-col justify-between gap-7">
                  <div>
                    <h3 className="font-mono text-xs uppercase tracking-widest text-[#ff6b35] mb-3">
                      Resultado
                    </h3>
                    <p className="text-lg sm:text-xl leading-snug">{solution.outcome}</p>
                  </div>
                  <a
                    href={buildSolutionWhatsappLink(solution)}
                    onClick={() => trackWhatsappClick(`solution_${solution.n}`)}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-brutal btn-brutal-orange justify-center text-center"
                  >
                    <span>{solution.cta}</span>
                    <ArrowRight size={18} className="shrink-0" />
                  </a>
                </aside>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  </main>
);

export default SolutionsPage;
